import { createContext, useContext } from "react";

/**
 * Shared top-header injection point.
 *
 * The app shell renders one slim header bar above every page. Instead of each page stacking its
 * own title/toolbar row underneath it (wasted vertical space), the active page portals its
 * controls — search, primary actions — straight into this slot. The value is the slot DOM node,
 * or null until it mounts.
 */
export const HeaderSlotContext = createContext(null);

export function useHeaderSlot() {
  return useContext(HeaderSlotContext);
}

/**
 * Titlebar injection point — a small slot inside the window titlebar's action cluster, just left
 * of the DevTools / theme buttons. Pages portal lightweight status text in here (e.g. Messages'
 * thread counter). Same contract as HeaderSlotContext: value is the slot DOM node or null.
 */
export const TitlebarSlotContext = createContext(null);

export function useTitlebarSlot() {
  return useContext(TitlebarSlotContext);
}
